/**
 * Akce pro číselník typů přestupků.
 */
import {list} from './..'
import EprApi from "./../api/EprApi";
import * as SharedActions from "./../shared/SharedActions"

function getList() {
    return EprApi.findTypyPrestupku(null)
        .then(data => {
            const newData = data.map(tp => {
                var popis = `${tp.zakon.cislo}/${tp.zakon.rok} - §${tp.paragraf}`;
                if (tp.odstavec && tp.odstavec.trim().length > 0) {
                    popis += ` odst. ${tp.odstavec.trim()}`;
                }
                if (tp.pismeno && tp.pismeno.trim().length > 0) {
                    popis += ` písm. ${tp.pismeno.trim()}`;
                }

                return {
                    ...tp,
                    popis: popis
                }
            })

            return {rows: newData, count: 0}
        });
}

export function fetchListIfNeeded(area) {
    return (dispatch, getState) => {
        dispatch(SharedActions.initIfNeeded(area, list.SimpleListReducer));

        dispatch(list.SimpleListActions.fetchIfNeeded(area, null, () => {
            return getList()
        }));
    }
}
